import { FC } from 'react'
import ModuleContactPage from '../ModuleContactPage'
import { ApiPagePage } from '../../../types/contentTypes'

const ModuleAwardsPanelPage: FC<{
  moduleProps: any
  landingContentData: ApiPagePage['attributes']
}> = () => {
  return <ModuleContactPage />
}

export default ModuleAwardsPanelPage
